import GLightbox from 'glightbox';

// eslint-disable-next-line no-unused-vars
const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});

/** Fix an aria-hidden bug on chrome browser */
lightbox.on('open', () => {
    const activeElement = document.activeElement;
    if (activeElement) {
        activeElement.blur();
    }
});



